<app-previewable [locked]="locked" [previewImage]="image" [previewTitle]="title" *transloco="let t">
  <figure>
    <a *ngIf="url" [href]="url" class="download" target="_blank">
      <div>{{ t('shared/download') }}</div>
      <div><i aria-hidden="true" class="fa fa-download"></i></div>
    </a>
    <img src="{{ image }}" alt="{{ title }}" />
  </figure>
</app-previewable>
